<template>
  <div class="my-password-change-firstlogin reverse-mobile row">
    <div class="col-12 col-md-9">
      <h3 class="title">Reset password</h3>
      <div class="subtitle">
        You must change your password on first login.
      </div>
      <div class="row">
        <div class="col-12">
          <div class="alert alert-success" v-if="passwordSent">
            <div>Your password has been updated.</div>
            <router-link to="/scenarios">
              <button class="btn btn-primary">
                Go to site
              </button>
            </router-link>
          </div>

          <form v-else @submit.prevent="updatePassword">
            <div class="alert alert-danger" v-if="errorFound">
              <strong>Whoops!</strong> {{ errorMessage }}
            </div>
            <div class="form-group">
              <div id="auth-messages" class="auth-messages"></div>
              <label for="newPassword">New Password</label>
              <input
                type="password"
                class="form-control"
                id="newPassword"
                aria-describedby="newPassword"
                v-model="passwordVal"
              />
              <label for="confirmPassword">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                id="confrimPassword"
                aria-describedby="confirmPassword"
                v-model="confirmVal"
              />
            </div>
            <div class="subtitle">
              Your password must be at least 8 characters long, containing at least
              one uppercase, lowercase and number.
            </div>
            <button id="sendButton" type="submit" class="btn btn-primary">
              {{ loading ? "..." : "Change Password" }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
  name: "MyPasswordChangeFirstLogin",
  data() {
    return {
      passwordVal: "",
      confirmVal: "",
      passwordSent: false,
      errorFound: false,
      loading: false,
      errorMessage: "Something went wrong"
    };
  },
  methods: {
    updatePassword() {
      if (this.loading) return;

      if (this.passwordVal !== this.confirmVal) {
        this.errorFound = true;
        this.errorMessage = "Passwords do not match";
        this.loading = false;
        return;
      }

      const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (!this.passwordVal.match(PASSWORD_REGEX)) {
        this.errorFound = true;
        this.errorMessage = "Invalid password";
        this.loading = false;
        return;
      }

      UserService.changePassword(this.passwordVal)
        .then(() => {
          this.passwordSent = true;
          this.errorFound = false;
        })
        .catch(() => {
          this.errorFound = true;
          this.errorMessage = "Something went wrong";
          this.passwordSent = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style scoped>
.auth-messages {
  display: none;
}

.my-password-change-firstlogin {
  margin-top: 6rem;
  margin-left: auto;
  margin-right: auto;
  max-width: 500px;
}

.title {
  margin-bottom: 0;
}
.subtitle {
  margin-top: 0;
  margin-bottom: 22px;
  line-height: 0.9rem;
  font-size: small;
}
.row {
  margin-top: 40px;
}
</style>
